<template>
    <el-container style="height: 100%">
        <el-main style="height: 100%">
            <el-form :inline="true" :model="searchParms">
                <el-form-item label="门店">
                    <el-cascader :options="storeData" clearable filterable v-model="searchParms.storeStructs" size="mini" style="width: 100%" @change="storeChange"></el-cascader>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="searchParms.sn" :true-label="1" :false-label="0" @change="btnquery">没SN码</el-checkbox>
                </el-form-item>
            </el-form>
            <el-table height="calc(100% - 4rem)" border :data="inteboSaleData" v-loadmore="loadmore" style="text-align: center;" highlight-current-row>
                <el-table-column label="门店"  align="center" prop="storename">
                    <template slot-scope="scope">
                        <div v-if="scope.row.storename">{{scope.row.parentname}}/{{scope.row.storename}}</div>
                        <div v-else>{{scope.row.parentname}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="SN码"  align="center" prop="sn">
                </el-table-column>
                <el-table-column label="型号"  align="center" prop="yqmodel">
                </el-table-column>
                <el-table-column label="操作"  align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button @click="openSn(scope.row)" type="text">修改SN码</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>
        <el-dialog title="SN登记" width="100%" :visible.sync="dialogVisible" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-form ref="form" :model="inteboSale" size="mini" label-width="80px" >
                <el-form-item label="单号" prop="sysbillid">
                    {{inteboSale.sysbillid}}
                </el-form-item>
                <el-form-item label="门店">
                    {{inteboSale.parentname}}/{{inteboSale.storename}}
                </el-form-item>
                <el-form-item label="仪器SN" prop="sn">
                    <el-input v-model="inteboSale.sn" @change="checkSn"></el-input>
                </el-form-item>
                <el-form-item label="仪器型号" prop="yqmodel">
                    <el-select v-model="inteboSale.yqmodel" placeholder="请选择" style="width: 100%" clearable>
                        <el-option value="C100" label="C100" key="C100"></el-option>
                        <el-option value="IA200" label="IA200" key="IA200"></el-option>
                        <el-option value="IA100" label="IA100" key="IA100"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" :loading="querybutton" size="mini" @click="saveInteboSn()">保存</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            isFinite:false,
            curpage:1,
            querybutton:false,
            dialogVisible:false,
            inteboSale:[],
            inteboSaleData:[],
            storeData:[],
            searchParms:{
                storeStructs:[],
                parentid:"",
                storeid:"",
                notpay:0,
                back:0,
                ht:0,
                tran:0,
                storesale:0,
                perf:0,
                sn:1
            }
        }
    },
    created() {
        this.getInteboStoreStructs();
        this.getInteboSaleByPage();
    },
    methods:{
        saveInteboSn(){
            this.querybutton=true;
            if(!this.inteboSale.sn){
                this.querybutton=false;
                this.$message({message: "请输入仪器SN码", type: 'error'});
                return;
            }
            if(!this.inteboSale.yqmodel){
                this.querybutton=false;
                this.$message({message: "请输入仪器型号", type: 'error'});
                return;
            }
            this.$postw("intebosale/saveInteboSn",this.inteboSale).then(res=>{
                if(res.sucess){
                    this.dialogVisible=false;
                    this.querybutton=false;
                    this.$message({message: "请输入仪器SN码", type: 'success'});
                    this.btnquery();
                }
            });
        },
        getInteboSaleById(sysbillid){
            this.$post("intebosale/getInteboSaleById",{sysbillid: sysbillid}).then(res=>{
                if(res.sucess){
                    this.inteboSale=res.object;
                    let array=[];
                    let jsArray=[];
                    if(this.inteboSale.jstype==2){
                        if(this.inteboSale.jstor){
                            jsArray.push(this.inteboSale.jstorparentid);
                            jsArray.push(this.inteboSale.jstor);
                        }
                    }
                    if(this.inteboSale.storeid){
                        array.push(this.inteboSale.parentid);
                        array.push(this.inteboSale.storeid);
                    }
                    else{
                        array.push(this.inteboSale.parentid);
                    }
                    this.$nextTick(function (){
                        this.parentstoreid=array;
                        this.storeParentNameData=jsArray;
                    });
                }
            });
        },
        checkSn(){
            this.querybutton=true;
            if(!this.inteboSale.sn){
                this.querybutton=false;
                return;
            }
            this.$post("intebosale/checkSn",{sn:this.inteboSale.sn}).then(res=>{
                this.querybutton=false;
                if(res.sucess){
                }
                else{
                    this.inteboSale.sn="";
                    this.$message({message: res.message, type: 'error'});
                }
            });
        },
        openSn(row){
            this.dialogVisible=true;
            this.getInteboSaleById(row.sysbillid);
        },
        btnquery(){
            this.isFinite=false;
            this.inteboSaleData=[];
            this.curpage=1;
            this.getInteboSaleByPage();
        },
        getInteboSaleByPage(){
            this.$post("intebosale/getInteboSaleByPage",{parentid:this.searchParms.parentid,
                storeid:this.searchParms.storeid,curpage:this.curpage,notpay: this.searchParms.notpay,
                back: this.searchParms.back,ht: this.searchParms.ht,tran:this.searchParms.tran,
                salestore:this.searchParms.storesale,perf:this.searchParms.perf,sn:this.searchParms.sn}).then(res=>{
                if(res.sucess){
                    let obj=res.object;
                    if(obj!=null && obj.length>0){
                        for(let val of obj){
                            this.inteboSaleData.push(val);
                        }
                    }
                    else{
                        this.isFinite=true;
                    }
                }
            });
        },
        storeChange(val){
            this.searchParms.parentid="";
            this.searchParms.storeid="";
            if(val[0]){
                this.searchParms.parentid=val[0];
            }
            if(val[1]){
                this.searchParms.storeid=val[1];
            }
            this.isFinite=false;
            this.inteboSaleData=[];
            this.curpage=1;
            this.getInteboSaleByPage();
        },
        loadmore(){
            if(this.isFinite==false){
                this.curpage++;
                this.getInteboSaleByPage();
            }
        },
        getInteboStoreStructs(){
            this.$post("inteboStore/getInteboStoreStructs").then(res=>{
                if(res.sucess){
                    this.storeData=res.object;
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/page/intebo/intebotab/intebosn.vue